/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {Entity} from '@ion/core/src/types/entities';
import {TemplateColumn} from '@ion/core/src/types/templates';

const BULK_DEVICE_COLUMNS = [
  {
    header   : 'identifiersList',
    error    : 'Value can not be greater than 32 characters.',
    max      : 32,
    required : true,
    width    : 30,
    type     : 'textLength',
    style    : {
      numFmt : '@'
    },
    key : 'deviceIdentifier'
  },
  {
    header   : 'Secondary Identifiers (Optional)',
    error    : 'Value can not be greater than 32 characters.',
    max      : 32,
    required : false,
    width    : 45,
    type     : 'textLength',
    style    : {
      numFmt : '@'
    },
    key : 'secondaryDeviceIdentifier'
  },
  {
    header   : 'VIN (Optional)',
    error    : 'Value can not be greater than 32 characters.',
    max      : 32,
    required : false,
    width    : 30,
    type     : 'textLength',
    style    : {
      numFmt : '@'
    },
    key : 'vin'
  },
  {
    header   : 'License Plate (Optional)',
    error    : 'Value can not be greater than 32 characters.',
    max      : 32,
    required : false,
    width    : 30,
    type     : 'textLength',
    style    : {
      numFmt : '@'
    },
    key : 'licensePlate'
  },
  {
    header   : 'License State (Optional)',
    error    : 'Value can not be greater than 32 characters.',
    max      : 32,
    required : false,
    width    : 30,
    type     : 'textLength',
    style    : {
      numFmt : '@'
    },
    key : 'licenseState'
  },
  {
    header   : 'Registration Renewal Date (Optional)',
    error    : 'Registration Renewal Date must be a valid Date (e.g. 16-06-2026).',
    max      : null,
    required : false,
    width    : 35,
    type     : 'date',
    key      : 'registrationRenewalDate'
  }
] as TemplateColumn[];

const BULK_ASSET_COLUMNS = [
  {
    header   : 'identifiersList',
    error    : 'Value can not be greater than 32 characters.',
    max      : 32,
    required : true,
    width    : 30,
    type     : 'textLength',
    style    : {
      numFmt : '@'
    },
    key : 'assetIdentifier'
  }
] as TemplateColumn[];

const BULK_ROLE_COLUMNS = [
  {
    header   : 'identifiersList',
    error    : 'Value can not be greater than 32 characters.',
    max      : 32,
    required : true,
    width    : 30,
    type     : 'textLength',
    style    : {
      numFmt : '@'
    },
    key : 'roleIdentifier'
  }
] as TemplateColumn[];

const templateColumnMap = {
  [Entity.device] : BULK_DEVICE_COLUMNS,
  [Entity.asset]  : BULK_ASSET_COLUMNS,
  [Entity.role]   : BULK_ROLE_COLUMNS
};

export const getTemplateColumns = (entity: Entity): TemplateColumn[] => {
  const columns = templateColumnMap[entity];
  if (!columns) {
    throw new Error(`Unsupported entity: ${entity}`);
  }
  return columns;
};
